import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AdminLayout from '@/layouts/AdminLayout';
import RequireAuth from '@/router/RequireAuth';
import LoginView from '@/views/auth/LoginView';
import DashboardView from '@/views/dashboard/DashboardView';
import CustomersView from '@/views/customers/CustomersView';
import CustomerDetailView from '@/views/customers/CustomerDetailView';
import CardsView from '@/views/cards/CardsView';
import WebhooksView from '@/views/webhooks/WebhooksView';
import UpstreamErrorLogsView from '@/views/upstream-errors/UpstreamErrorLogsView';
import UpstreamCommLogsView from '@/views/upstream-comm/UpstreamCommLogsView';
import SandboxSimulateView from '@/views/sandbox/SandboxSimulateView';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginView />} />
        <Route
          element={
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardView />} />
          <Route path="/customers" element={<CustomersView />} />
          <Route path="/customers/:id" element={<CustomerDetailView />} />
          <Route path="/cards" element={<CardsView />} />
          <Route path="/webhooks" element={<WebhooksView />} />
          <Route path="/upstream-errors" element={<UpstreamErrorLogsView />} />
          <Route path="/upstream-comm" element={<UpstreamCommLogsView />} />
          <Route path="/sandbox/simulate" element={<SandboxSimulateView />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
